import React from "react";
import * as FaIcons from "react-icons/fa";
import { Link } from "react-router-dom";
import wecook from "../../assets/wecook.png";
import { Image } from "react-bootstrap";




const MernRealisations = () => {
    return (
        <div className="d-inline-block px-0"> 
            <div className="d-inline-block col ">
                <div className="card shadow-sm">
                    <h6>wecook, creation et partage des recettes de cuisine</h6>
                    <Image src={wecook} style={{ height: '300px', width: "100%", margin: "auto", padding:"5px" }} alt="capture ecrans site" fluid="true" />
                    <p className="pMemory">Appli MERN (ReactJs/Redux, Express, NodeJS, MongoDB ) <Link to={{ pathname: "https://wecook.netlify.app/" }} target="_blank">&nbsp;&nbsp;&nbsp;<span className="pMemory">Visiter</span><FaIcons.FaExternalLinkAlt style={{ color: "#daef0a" }} /></Link>
                    </p>
                    <p className="pMemory">Déployée avec Heroku pour le backend (l'API), Netlify pour le frontend, MongoDb Atlas pour la base de données, et AWS S3 pour le stockage physique des images.</p>
                </div>
            </div>
        </div>
    )
}

export default MernRealisations;